import { render, staticRenderFns } from "./unmark-as-spam.vue?vue&type=template&id=587da4ed&"
import script from "./unmark-as-spam.vue?vue&type=script&lang=js&"
export * from "./unmark-as-spam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports